import { z } from "zod";
import type { DocumentTypeConfig } from "../types";

export const ProfessionalCardDataSchema = z.object({
  first_name: z.string(),
  last_name: z.string(),
  document_number: z.string(),
  issue_date: z.string(),
  expiration_date: z.string(),
});

export type ProfessionalCardData = z.infer<typeof ProfessionalCardDataSchema>;

export const ProfessionalCardExtractionSchema = z.object({
  isValidDocumentType: z.boolean(),
  reason: z.string().optional(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  document_number: z.string().nullable(),
  issue_date: z.string().nullable(),
});

export type ProfessionalCardExtraction = z.infer<typeof ProfessionalCardExtractionSchema>;

export const ProfessionalCardContextSchema = z.object({
  talentId: z.guid(),
});

export type ProfessionalCardContext = z.infer<typeof ProfessionalCardContextSchema>;

type ProfessionalCardConfig = DocumentTypeConfig<
  typeof ProfessionalCardDataSchema,
  typeof ProfessionalCardContextSchema
>;

export const PROFESSIONAL_CARD_CONFIG: ProfessionalCardConfig = {
  documentType: "professional_card",
  documentName: "Carte BTP",
  maxFiles: 1,
  acceptedMimeTypes: ["image/jpeg", "image/png", "application/pdf"],
  dataSchema: ProfessionalCardDataSchema,
  contextSchema: ProfessionalCardContextSchema,
  requiredFields: ["first_name", "last_name", "document_number", "issue_date", "expiration_date"],
  fieldLabels: {
    first_name: "Prénom",
    last_name: "Nom",
    document_number: "Numéro de carte",
    issue_date: "Date de délivrance",
    expiration_date: "Date d'expiration",
  },
};

export const PROFESSIONAL_CARD_VALIDITY_YEARS = 5;
